import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-054b64e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_3 = { class: "card-header border-bottom" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_8 = { class: "card-body p-9" }
const _hoisted_9 = { class: "mb-10" }
const _hoisted_10 = { class: "section-header mb-6" }
const _hoisted_11 = { class: "fw-bold text-dark mb-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_13 = { class: "row g-6" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_16 = { class: "info-item mb-4" }
const _hoisted_17 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_18 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_19 = { class: "fw-bold text-gray-800" }
const _hoisted_20 = { class: "info-item mb-4" }
const _hoisted_21 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_22 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_23 = { class: "fw-bold text-gray-800" }
const _hoisted_24 = { class: "info-item mb-4" }
const _hoisted_25 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_26 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_27 = { class: "fw-bold text-gray-800" }
const _hoisted_28 = { class: "info-item mb-4" }
const _hoisted_29 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_30 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_31 = { class: "fw-bold text-gray-800" }
const _hoisted_32 = { class: "info-item mb-4" }
const _hoisted_33 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_34 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_35 = { class: "fw-bold text-gray-800" }
const _hoisted_36 = { class: "info-item" }
const _hoisted_37 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_38 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_39 = { class: "col-lg-6" }
const _hoisted_40 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_41 = { class: "info-item mb-4" }
const _hoisted_42 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_43 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_44 = { class: "fw-bold text-gray-800" }
const _hoisted_45 = { class: "info-item mb-4" }
const _hoisted_46 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_47 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_48 = { class: "fw-bold text-gray-800" }
const _hoisted_49 = { class: "info-item mb-4" }
const _hoisted_50 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_51 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_52 = { class: "fw-bold text-gray-800" }
const _hoisted_53 = { class: "info-item mb-4" }
const _hoisted_54 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_55 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_56 = { class: "fw-bold text-gray-800" }
const _hoisted_57 = { class: "info-item mb-4" }
const _hoisted_58 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_59 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_60 = { class: "fw-bold text-gray-800" }
const _hoisted_61 = { class: "info-item" }
const _hoisted_62 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_63 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_64 = { class: "mb-10" }
const _hoisted_65 = { class: "section-header mb-6" }
const _hoisted_66 = { class: "fw-bold text-dark mb-1" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_68 = { class: "row g-6" }
const _hoisted_69 = { class: "col-12" }
const _hoisted_70 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_71 = { class: "row g-4" }
const _hoisted_72 = { class: "col-md-12" }
const _hoisted_73 = { class: "info-item" }
const _hoisted_74 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_75 = { class: "info-value p-3 bg-white rounded border border-gray-200 text-center" }
const _hoisted_76 = { class: "mb-0" }
const _hoisted_77 = { class: "section-header mb-6" }
const _hoisted_78 = { class: "fw-bold text-dark mb-1" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300" }, null, -1))
const _hoisted_80 = { class: "row g-6" }
const _hoisted_81 = { class: "col-lg-6" }
const _hoisted_82 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_83 = { class: "fw-bold text-gray-700 mb-4" }
const _hoisted_84 = { class: "info-item mb-4" }
const _hoisted_85 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_86 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_87 = { class: "fw-bold text-gray-800" }
const _hoisted_88 = { class: "info-item mb-4" }
const _hoisted_89 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_90 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_91 = { class: "fw-bold text-gray-800" }
const _hoisted_92 = { class: "info-item" }
const _hoisted_93 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_94 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_95 = { class: "fw-bold text-success" }
const _hoisted_96 = { class: "col-lg-6" }
const _hoisted_97 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_98 = { class: "fw-bold text-gray-700 mb-4" }
const _hoisted_99 = { class: "info-item mb-4" }
const _hoisted_100 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_101 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_102 = { class: "fw-bold text-gray-800" }
const _hoisted_103 = { class: "info-item mb-4" }
const _hoisted_104 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_105 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_106 = { class: "fw-bold text-gray-800" }
const _hoisted_107 = { class: "info-item" }
const _hoisted_108 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_109 = { class: "info-value p-3 bg-white rounded border border-gray-200" }
const _hoisted_110 = { class: "fw-bold text-success" }
const _hoisted_111 = { class: "col-lg-12" }
const _hoisted_112 = { class: "info-card p-6 bg-gray-50 rounded border" }
const _hoisted_113 = { class: "info-item" }
const _hoisted_114 = { class: "form-label text-gray-600 fw-semibold mb-2" }
const _hoisted_115 = { class: "info-value p-3 bg-white rounded border border-gray-200 text-center" }
const _hoisted_116 = { class: "fw-bold text-gray-800 fs-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.can('read', 'payments') && _ctx.purchaseLog)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.translate('purchaseLogDetails')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "btn btn-light",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('backToList')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.translate('transactionInfo')), 1),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.translate('transactionId')) + ":", 1),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.purchaseLog.transactionId || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.translate('service')) + ":", 1),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.purchaseLog.service), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.translate('packageName')) + ":", 1),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.purchaseLog.packageName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.translate('customerName')) + ":", 1),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.purchaseLog.customerName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.translate('phone')) + ":", 1),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.purchaseLog.phoneNumber), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.translate('accountType')) + ":", 1),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge ${
                        _ctx.purchaseLog.accountType === 'Office'
                          ? 'badge-light-primary'
                          : 'badge-light-info'
                      } fw-bold`)
                        }, _toDisplayString(_ctx.purchaseLog.accountType), 3)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.translate('paidAmount')) + ":", 1),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.purchaseLog.paidAmount) + " KWD", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.translate('amount')) + ":", 1),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.purchaseLog.amount) + " KWD", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.translate('paymentMethod')) + ":", 1),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.purchaseLog.paymentMethod), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.translate('purchaseDateTime')) + ":", 1),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.purchaseLog.purchaseDateTime), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.translate('expiresAt')) + ":", 1),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.purchaseLog.expiresAt || 'N/A'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.translate('isActive')) + ":", 1),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge ${
                        _ctx.purchaseLog.isActive
                          ? 'badge-light-success'
                          : 'badge-light-danger'
                      } fw-bold`)
                        }, _toDisplayString(_ctx.purchaseLog.isActive
                          ? _ctx.translate('active')
                          : _ctx.translate('inactive')), 3)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("h3", _hoisted_66, _toDisplayString(_ctx.translate('statusInfo')), 1),
                _hoisted_67
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.translate('transactionStatus')) + ":", 1),
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("span", {
                              class: _normalizeClass(`badge ${
                            _ctx.purchaseLog.status === 'PAID'
                              ? 'badge-success'
                              : _ctx.purchaseLog.status === 'UNPAID'
                              ? 'badge-danger'
                              : 'badge-warning'
                          } fw-bold`)
                            }, _toDisplayString(_ctx.purchaseLog.status), 3)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("h3", _hoisted_78, _toDisplayString(_ctx.translate('creditsAndUsage')), 1),
                _hoisted_79
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("h4", _hoisted_83, _toDisplayString(_ctx.translate('iveCredits')), 1),
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.translate('totalIveCredits')) + ":", 1),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.purchaseLog.totalIveCredits), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.translate('usedIveCredits')) + ":", 1),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.purchaseLog.usedIveCredits), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.translate('remainingIve')) + ":", 1),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.purchaseLog.remainingIve), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("h4", _hoisted_98, _toDisplayString(_ctx.translate('advertisements')), 1),
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.translate('totalAds')) + ":", 1),
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.purchaseLog.totalAds), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.translate('usedAds')) + ":", 1),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.purchaseLog.usedAds), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_107, [
                      _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.translate('remainingAds')) + ":", 1),
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.purchaseLog.remainingAds), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.translate('remainingDays')) + ":", 1),
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.purchaseLog.remainingDays) + " " + _toDisplayString(_ctx.translate('days')), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}